import React, { useState } from "react";
import fb from '../sn-2.png'; 
import tw from '../sn-3.png'; 

function Gallery(){
    const [number, setNumber] = useState(1); 

    let comic = [
        {
            title: "Opportunities",
            descripcion: "descripcion",
            fb: "https://www.facebook.com/jebusdoodles/photos/a.2162645950479170/3556210101122741/",
            tw: "https://twitter.com/JebusDoodles/status/1325708328970772480"
        },
        {
            title: "End of the year", 
            descripcion: "descripcion 2",
            fb: "https://www.facebook.com/jebusdoodles/photos/a.1979994188744348/3564279323649152/",
            tw: "https://twitter.com/JebusDoodles/status/1326914062651973632"
        },
        {
            title: "Ghostbusters", 
            descripcion: "descripcion 2",
            fb: "https://www.facebook.com/jebusdoodles/photos/a.1979994188744348/3600044080072676/",
            tw: "https://twitter.com/JebusDoodles/status/1331713233208557568"
        },
        {
            title: "Goals", 
            descripcion: "descripcion 2",
            fb: "https://www.facebook.com/jebusdoodles/photos/a.1979994188744348/3603822579694826/",
            tw: "https://twitter.com/JebusDoodles/status/1332235317814972419"
        },
        {
            title: "Pyramid scheme", 
            descripcion: "descripcion 2",
            fb: "https://www.facebook.com/jebusdoodles/photos/a.1979994188744348/3653577888052628/",
            tw: "https://twitter.com/JebusDoodles/status/1339252796470616065"
        },
        {
            title: "Unexpected visitor", 
            descripcion: "descripcion 2",
            fb: "https://www.facebook.com/jebusdoodles/photos/a.1979994188744348/3659549984122085/",
            tw: "https://twitter.com/JebusDoodles/status/1340106368179564544"
        },
        {
            title: "Reflection", 
            descripcion: "descripcion 2",
            fb: "https://www.facebook.com/jebusdoodles/photos/a.2162645950479170/3575508512526233/",
            tw: "https://twitter.com/JebusDoodles/status/1328251670912925697"
        }
    ]

    const handleIncrement = () => {
        setNumber(prevNumber => prevNumber + 1); 
    }

    const handleDecrement = () => {
        setNumber(prevNumber => prevNumber - 1); 
    }
    return(
        <div className="gallery-container">
            <h2 className="title-gallery">
                {comic[number-1].title}
            </h2>
            {
                number >= 7 ? " " : <div 
                    className="btn-ant g-element arrow left" 
                    onClick={handleIncrement}
                />
            }
            <img 
                className="comic-principal g-element" 
                src={"./comics/0"+number+".jpg"}
                alt={"comic"+number}
            />
            { 
                number === 1 ? " " : <div 
                    className="btn-sig g-element arrow right" 
                    onClick={handleDecrement} 
                /> 
            }
            <div className="social-box">
                <a 
                    href={comic[number-1].fb}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={fb} className="icon-sn" alt="fb-icon" />
                </a>
                <a 
                    href={comic[number-1].tw}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img src={tw} className="icon-sn" alt="tw-icon"/>
                </a>
            </div>
        </div>
    );
}

export default Gallery;